import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/consignment-inbound-request/constants/consignment-inbound-request-constants'
import PropTypes from 'prop-types'
import React from 'react'

const proptypes = {
  status: PropTypes.string
}

/**
 * To give nice look on Consignment Inbound Request `status`.
 * It maps `status` to certain style and pass to `StatusBadge`.
 * @param {string} status Consignment Inbound Request status. available values
 * - 'pending'
 * - 'confirmed'
 * - 'picking'
 * - 'received'
 * - 'cancelled'
 */
const ConsignmentInboundRequestStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.PENDING]   : 'warning',
    [STATUS.CONFIRMED] : 'success',
    [STATUS.PICKING]   : 'info',
    [STATUS.RECEIVED]  : 'success',
    [STATUS.CANCELLED] : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

ConsignmentInboundRequestStatusBadge.propTypes = proptypes

export default ConsignmentInboundRequestStatusBadge
